import { render } from "./Detail.vue?vue&type=template&id=5909dc26&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=5909dc26&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-uk-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5909dc26"]])

export default __exports__